module.exports = __webpack_public_path__ + "static/media/leaderboard@2x.e1bc8fa6.jpg";